var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBiosimilars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10932_239173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2649 0C10.0021 0 8.81465 0.49183 7.92259 1.3846L1.37713 7.93006C0.484358 8.82314 -0.0078125 10.0103 -0.0078125 11.2727C-0.0078125 13.8793 2.11292 16 4.71948 16C5.98299 16 7.16976 15.5082 8.06182 14.6154L14.6073 8.07031C15.5007 7.1772 15.9922 5.99005 15.9922 4.72725C15.9922 2.12073 13.8715 0 11.2649 0ZM5.10157 7.2912L2.91975 9.47268C2.43893 9.9535 2.17401 10.593 2.17401 11.2727C2.17401 11.4737 2.01136 11.6364 1.81036 11.6364C1.60936 11.6364 1.44671 11.4737 1.44671 11.2727C1.44671 10.3985 1.7869 9.57672 2.40552 8.95848L4.58734 6.77701C4.7294 6.63495 4.95951 6.63495 5.10153 6.77701C5.24362 6.91903 5.24362 7.14914 5.10157 7.2912ZM13.5789 7.04189L10.5633 10.0571L5.93533 5.42867L8.95101 2.41299C9.56891 1.79475 10.3906 1.45452 11.2649 1.45452C13.0696 1.45452 14.5377 2.92258 14.5377 4.72725C14.5377 5.60155 14.1975 6.42365 13.5789 7.04189Z",
    fill: "#D1DAE7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10932_239173"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiosimilars);
export default __webpack_public_path__ + "static/media/Biosimilars.e0895dabbd3faec2fb5174014c4b69d0.svg";
export { ForwardRef as ReactComponent };